import { withJsonFormsControlProps } from "@jsonforms/react";
import { useEffect } from "react";
import DecimalInputField from "./DecimalInputField";

const DecimalInputComponent = (props) => {
  const {
    handleChange,
    label,
    data,
    path,
    errors,
    schema,
    uischema,
    required,
    enabled,
    visible,
  } = props;

  useEffect(() => {
    if (!enabled && data) {
      handleChange(path, "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);

  const updateValue = (newVal) => {
    handleChange(path, newVal);
  };
  return (
    <DecimalInputField
      value={data}
      disabled={!enabled}
      label={uischema.showLabel === false ? "" : label}
      updateValue={updateValue}
      errors={errors}
      schema={schema}
      uiSchema={uischema}
      required={required}
      visible={visible}
    />
  );
};

export const DecimalInputControl = withJsonFormsControlProps(DecimalInputComponent);
